import React from 'react';
import { Flex, Text, Button, Dialogs } from '@leverege/ui-elements';
import CaseData from './CaseData';
import Accordion from '../../../../views/Accordion';
import TRLoader from './TRLoader';
import S from './TheftRecovery.css';
import DisableDialog from './DisableDialog';
import { theftRecoverySupport } from '../Templates';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class TheftRecoveryActive extends React.Component {
  onClick = () => {
    Dialogs.show({
      component: DisableDialog,
      props: {
        ...this.props
      }
    });
  };
  contactSupport = () => {
    const {
      onClose,
      sharedProps: {
        item
      }
    } = this.props;
    const messageText = theftRecoverySupport.replace('$VIN', item?.data?.vin || 'Unknown');
    window?.Intercom?.('showNewMessage', messageText);
    onClose?.();
  };
  onChange = ({
    data,
    value
  }) => {
    const {
      setLoading
    } = this.props;
    setLoading(value);
  };
  render() {
    const {
      loading,
      caseData,
      caseActions
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "colL",
      children: [!caseData && /*#__PURE__*/_jsx(TRLoader, {
        spinning: true
      }), caseData && /*#__PURE__*/_jsx(CaseData, {
        caseData: caseData,
        caseActions: caseActions
      }), /*#__PURE__*/_jsx(Accordion, {
        title: /*#__PURE__*/_jsx(Text, {
          variant: "theftRecoverySubtitle",
          icon: "https://recovr-ui-assets.storage.googleapis.com/icon-system-error-2x.png",
          children: "This will NOT contact the police. Please call 911 to file a police report."
        }),
        content: /*#__PURE__*/_jsxs(Flex, {
          className: S.list,
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "captionBold",
            children: "Notes for Contacting Law Enforcement:"
          }), /*#__PURE__*/_jsx(Text, {
            variant: "accordionItem",
            children: "Express that your vehicle has been stolen"
          }), /*#__PURE__*/_jsx(Text, {
            variant: "accordionItem",
            children: "Mention that you have a RecovR Security Device hidden in your vehicle which you have enabled to actively track the vehicle location"
          }), /*#__PURE__*/_jsx(Text, {
            variant: "accordionItem",
            children: "Share the theft recovery URL, case number, and access code so others can access theft tracking"
          })]
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: loading,
        onClick: this.contactSupport,
        variant: "secondary",
        className: S.button,
        children: "Contact Support"
      }), /*#__PURE__*/_jsx(Button, {
        disabled: loading,
        onClick: this.onClick,
        variant: "primaryDestructive",
        className: S.button,
        children: "End Theft Recovery"
      })]
    });
  }
}